import {stepFrom} from 'helpers/date'

//- 必要台数概算

export default {
  data() {
    return {
      colApproxRE: 0,
      colApproxes: [],
    }
  },

  methods: {
    makeApprox() {
      this.colApproxRE = 0
      const cols = this.cols.map(() => 0)
      if (this.store != null) {
        this.colApproxRE = this.store.re4
        if (0 < this.colApproxRE) {
          for(const estimate of this.estimates) {
            const step = stepFrom(estimate.time)
            if(this.displayBeginStep <= step && step < this.displayEndStep) {
              cols[step - this.displayBeginStep] = Math.ceil(estimate.customers / this.colApproxRE)
            }
          }
        }
      }
      this.colApproxes = cols
    },
  },
}
